<template>
  <div class="changeSign">
    <div class="sign">
      <van-field
        label-class="si"
        v-model="sign"
        size="large"
        rows="4"
        autosize
        type="textarea"
        maxlength="500"
        placeholder="请输入内容..."
        show-word-limit
      />
    </div>
    <div class="tip">签名会显示在个人名片上</div>
    <div class="btn" @click="changeSign">确定</div>
  </div>
</template>

<script>
import { Field, Toast } from "vant";
import { postPersonality } from "@api/public";
export default {
  name: "ChangeSign",
  components: {
    [Field.name]: Field
  },
  data() {
    return {
      sign: ""
    };
  },
  mounted() {
    this.sign = this.$route.query.sign;
  },
  methods: {
    changeSign() {
      postPersonality({ personality: this.sign })
        .then(res => {
          if (res.status == 200) {
            Toast({ message: "修改成功" });
            this.$router.replace({ path: "/my/card" });
          } else {
            Toast({ message: "修改失败" });
          }
        })
        .catch(err => {
          Toast({ message: err.msg });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.changeSign {
  .si {
    font-size: 0.26rem;
  }
  .sign {
    margin: 0.2rem 0.3rem 0 0.3rem;
    border-radius: 0.1rem;
  }
  .tip {
    margin: 0 0.3rem;
    font-size: 0.24rem;
    line-height: 0.8rem;
    color: #999999;
  }
  .btn {
    margin: 0.16rem 0.3rem 0 0.3rem;
    background: #ff410a;
    line-height: 0.8rem;
    text-align: center;
    border-radius: 0.16rem;
    color: #ffffff;
    letter-spacing: 0.06rem;
  }
}
</style>
